<template>
  <div class="examination-container px-4">
    <h2 class="main-title">
      <span>Novi pregled: </span>
      <span><span class="teal--text mr-4">Ime: {{ petInfo.name }}</span></span>
      <span><span class="green--text">Br. kartona: {{ petInfo.petId }}</span></span>
    </h2>
    <div class="main-container">
      <div class="d-flex flex-wrap examination-form">
        <div>
          <p>Anamaneza</p>
          <textarea v-model="examinationInfo.anamneza"></textarea>
        </div>
        <div>
          <p>Klinička slika</p>
          <textarea v-model="examinationInfo.klinickaSlika"></textarea>
        </div>
        <div>
          <p>Dijagnoza</p>
          <textarea v-model="examinationInfo.dijagnoza"></textarea>
        </div>
        <div>
          <p>Terapija</p>
          <textarea v-model="examinationInfo.terapija"></textarea>
        </div>
        <div>
          <p>Specijalne metode dijagnostike</p>
          <textarea
            v-model="examinationInfo.specijalneMetodeDijagnostike"
          ></textarea>
        </div>
        <div>
          <p>Napomena</p>
          <textarea
            v-model="examinationInfo.napomena"
          ></textarea>
        </div>
        <div>
          <p>Dokumenta</p>
          <v-file-input
            class="pt-0"
            multiple
            truncate-length="15"
            @change="uploadFiles"
            v-model="examinationInfo.files"
          ></v-file-input>
        </div>
        <div style="flex: 0 0 100%">
          <hr />
        </div>
        <div class="d-flex">
          <v-radio-group
            row
            v-model="radioGroup"
            class="d-flex flex-row justify-space-between"
          >
            <v-radio label="Besnilo" value="Besnilo"></v-radio>
            <v-radio label="Zarazne bolesti" value="Zarazne bolesti"></v-radio>
          </v-radio-group>
        </div>
        <div>
          <v-text-field
            label="Naziv vakcine"
            outlined
            dense
            v-model="examinationInfo.vaccine.name"
          ></v-text-field>
        </div>
        <div>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="dateFrom"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFrom"
                label="Datum vakcinacije"
                append-icon="mdi-calendar"
                readonly
                outlined
                dense
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateFrom" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDateFrom"> Otkaži </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(dateFrom)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </div>
        <div>
          <v-menu
            ref="menu1"
            v-model="menu1"
            :close-on-content-click="false"
            :return-value.sync="dateTo"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateTo"
                label="Datum naredne vakcinacije"
                append-icon="mdi-calendar"
                readonly
                outlined
                dense
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="dateTo" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="closeDateTo">
                Otkaži
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu1.save(dateTo)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
        </div>
        <div style="flex: 0 0 100%">
          <hr />
        </div>
        <div class="d-flex flex-column">
          <p>Cena</p>
          <v-text-field
            outlined
            dense
            v-model="examinationInfo.price"
          ></v-text-field>
        </div>
      </div>
      <div class="d-flex justify-end mt-3">
        <v-btn class="teal" @click="manageExamination()">Sačuvaj</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      filePrepared: null,
      radioGroup: [],
      menu: false,
      menu1: false,
      dateFrom: "",
      dateTo: "",
      files: null,
    };
  },
  computed: {
    ...mapState(["lang", "examinationInfo", "snackbar", "petInfo"]),
  },
  methods: {
    closeDateFrom () {
      this.menu = false
      this.dateFrom = ""
      this.$refs.menu.save("")
    },
    closeDateTo () {
      this.menu = false
      this.dateTo = ""
      this.$refs.menu1.save("")
    },
    uploadFiles(file) {
      this.filePrepared = file;
      if (file && this.$route.query.appointmentId) {
        var fd = new FormData();
        this.filePrepared.forEach((element) => {
          var fileName = ''
          var splitted = element.name.split('.')
          splitted[splitted.length - 2] = splitted[splitted.length - 2] + '____' + Date.now() + '____'
          splitted = splitted.join('.')
          fileName = splitted
          fd.append("files", element, fileName);
        });
        var obj = {
          file: fd,
          appointmentId: this.$route.query.appointmentId,
        };
        this.$store.commit("loading", true);
        this.$store.dispatch("uploadDocument", obj).then((response) => {
          this.files = response;
          this.$store.commit("loading", false);
        });
      } else {
        this.files = null;
      }
    },
    setupForm() {
      this.$store.state.examinationInfo = {
        date: "",
        anamneza: "",
        klinickaSlika: "",
        dijagnoza: "",
        terapija: "",
        specijalneMetodeDijagnostike: "",
        napomena: "",
        files: [],
        vaccine: {
          vaccineId: null,
          type: "",
          name: "",
          date: "",
          nextDate: "",
        },
      };
    },
    updateExamination() {
      this.$store.dispatch("updateExamination", {
        appointmentId: this.$route.query.appointmentId,
        petId: this.$route.query.petId,
      });
    },
    insertExamination() {
      this.$store.dispatch("insertExamination", {
        petId: this.$route.query.petId,
        file: this.filePrepared,
      });
    },
    manageExamination() {
      if ((this.radioGroup.length || this.dateFrom || this.dateTo) && !this.examinationInfo.vaccine.name) {
        this.$store.commit('toast', {message: 'Naziv vakcine je obavezno polje', color: 'red'})
        return
      }
      if (!this.examinationInfo.vaccine.name) {
        if (!this.examinationInfo.anamneza && !this.examinationInfo.klinickaSlika && !this.examinationInfo.dijagnoza && !this.examinationInfo.terapija && !this.examinationInfo.specijalneMetodeDijagnostike && !this.examinationInfo.napomena) {
          this.$store.commit('toast', {message: 'Polja su prazna', color: 'red'})
          return
        }
      }
      if (this.$route.query.appointmentId) {
        this.updateExamination(this.$route.query.appointmentId);
      } else {
        this.insertExamination();
      }
    }
  },
  mounted() {
    if (this.$route.query.petId) {
      this.$store.dispatch("getPet", this.$route.query.petId);
    }
    if (this.$route.query.appointmentId) {
      this.$store.dispatch("getExamination", this.$route.query.appointmentId);
    } else {
      var emptyExaminationInfo = {
        date: "",
        anamneza: "",
        klinickaSlika: "",
        dijagnoza: "",
        terapija: "",
        specijalneMetodeDijagnostike: "",
        files: [],
        vaccine: {
          vaccineId: "",
          type: "",
          name: "",
          date: "",
          nextDate: "",
        },
      };
      this.$store.commit("setExaminationInfo", emptyExaminationInfo);
    }
  },
  watch: {
    "$store.state.dateRadioChanged": {
      immediate: true,
      deep: true,
      handler() {
        this.radioGroup = this.$store.state.examinationInfo.vaccine.type;
        this.dateFrom = this.$store.state.examinationInfo.vaccine.date;
        this.dateTo = this.$store.state.examinationInfo.vaccine.nextDate;
      },
    },
    radioGroup(newValue) {
      this.$store.state.examinationInfo.vaccine.type = newValue;
    },
    dateFrom(newValue) {
      if (newValue) this.$store.state.examinationInfo.vaccine.date = newValue;
    },
    dateTo(newValue) {
      if (newValue)
        this.$store.state.examinationInfo.vaccine.nextDate = newValue;
    },
  },
};
</script>

<style lang="scss">
.theme--light.v-file-input .v-file-input__text,
.mdi-paperclip {
  color: #fff !important;
}
.examination-form {
  padding: 30px 20px;
  border-radius: 4px;
  background: $bg2;
  width: 100%;
  flex: 0 0 100%;
  > div {
    width: 50%;
    padding: 10px;
    p {
      margin-bottom: 0;
    }
    textarea {
      width: 100%;
      min-height: 100px;
      color: #fff;
      padding: 5px;
      background: $bg1;
    }
    .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
      > .v-input__control
      > .v-input__slot {
      background: #262626 !important;
    }
  }
  > div:last-child {
    flex: 0 0 100%;
    display: flex;
    justify-content: flex-end;
  }
}
@media (max-width: 768px) {
  .examination-container {
    .main-title {
      > span {
        display: block;
        font-size: 20px;
      }
    }
  }
  .examination-form {
    padding: 0;
    flex: 0 0 100%;
    > div {
      width: 100%;
      padding: 10px;
      textarea {
        min-height: 80px;
        padding: 5px;
      }
    }
  }
}
</style>